module.exports = __webpack_public_path__ + "img/like.d7ed185b.png";